// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_app from "lui/lui_app.js";
import * as Lui_protocol from "lui/lui_protocol.js";
import * as Lui_web from "lui.web.dom/shell/lui_web.js";
import * as Mapre_web__Web_controller from "./web_controller.js";
import * as Mapre_web__Web_extensions from "./web_extensions.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_view from "./web_view.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

const icons = Stdlib__List.fold_left((function (icons, name) {
  return Curry._3(Lui_protocol.String_map.add, name, "/icons/" + (name + ".svg"), icons);
}), Lui_protocol.String_map.empty, {
  hd: "chevron-down",
  tl: {
    hd: "chevron-right",
    tl: {
      hd: "circle-dot",
      tl: {
        hd: "edit",
        tl: {
          hd: "search",
          tl: {
            hd: "panel-left",
            tl: {
              hd: "settings",
              tl: {
                hd: "user",
                tl: {
                  hd: "users",
                  tl: {
                    hd: "stop",
                    tl: {
                      hd: "copy",
                      tl: {
                        hd: "arrow-up",
                        tl: {
                          hd: "arrow-down",
                          tl: {
                            hd: "refresh-cw",
                            tl: {
                              hd: "folder",
                              tl: {
                                hd: "git-branch",
                                tl: {
                                  hd: "file-text",
                                  tl: {
                                    hd: "terminal",
                                    tl: {
                                      hd: "archive",
                                      tl: {
                                        hd: "git-pull-request",
                                        tl: {
                                          hd: "ellipsis",
                                          tl: {
                                            hd: "menu",
                                            tl: {
                                              hd: "x",
                                              tl: {
                                                hd: "check-circle",
                                                tl: {
                                                  hd: "send",
                                                  tl: {
                                                    hd: "plus",
                                                    tl: /* [] */ 0
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

function start(param) {
  const host = document.querySelector("#app");
  if (host == null) {
    return Stdlib.invalid_arg("missing_application_host");
  }
  const match = Mapre_web__Web_extensions.renderer(icons, host);
  const renderer = match[0];
  const controller = {
    contents: undefined
  };
  const view = function (context, source, _send) {
    return Mapre_web__Web_view.view(context, source, (function (action) {
      Stdlib__Option.iter((function (c) {
        Mapre_web__Web_controller.dispatch(c, action);
      }), controller.contents);
      return true;
    }));
  };
  const app = Lui_app.create_with_extensions(Lui_web.backend(renderer), match[1], Mapre_web__Web_model.initial, Mapre_web__Web_model.update, view);
  const emit = function (action) {
    Lui_app.send(app, action);
    Lui_app.flush(app);
  };
  Lui_web.set_event_handler(renderer, (function ($$event) {
    Lui_app.dispatch_event(app, $$event);
    return Lui_app.flush(app);
  }));
  Lui_app.start(app);
  Lui_app.flush(app);
  Lui_web.mount(renderer, app.app_root_node, host);
  controller.contents = Caml_option.some(Mapre_web__Web_controller.create(emit, (function (param) {
    return Lui_app.model(app);
  })));
}

export {
  start,
}
/* icons Not a pure module */
